import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDvDBm2kAo0AYBBiuZxMScs97SuItVBVkU",
    authDomain: "personal-website-b7651.firebaseapp.com",
    projectId: "personal-website-b7651",
    storageBucket: "personal-website-b7651.firebasestorage.app",
    messagingSenderId: "1012383632471",
    appId: "1:1012383632471:web:3532cd7a5b1ac906e82712",
    measurementId: "G-0LQ08726LZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
const analytics = getAnalytics(app);

export { app, analytics };